<!-- 编辑保养计划 -->
<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" width="800" draggable>
            <!-- 人员基本信息 -->
            <div class="userAdd_man">
                <!-- 保养项目表单 -->
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.planProject')" prop="title">
                            <el-input v-model="state.form.title" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.planContent')" prop="content">
                            <el-input v-model="state.form.content" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.requiredMaterials')" prop="required_materials">
                            <el-input v-model="state.form.required_materials" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.dose')" prop="dose">
                            <el-input v-model="state.form.dose" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.frequencyType')" prop="frequency_type">
                            <el-radio v-model="state.form.frequency_type" :label="0">{{ t('maintenance.fixedCycle') }}</el-radio>
                            <el-radio v-model="state.form.frequency_type" :label="1">{{ t('maintenance.driveKm') }}</el-radio>
                            <el-radio v-model="state.form.frequency_type" :label="2">{{ t('maintenance.workHoursType') }}</el-radio>

                        </el-form-item>
                    </el-col>
                    <el-col v-if="state.form.frequency_type === 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.days')" prop="day">
                            <el-input-number v-model="state.form.day" />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="state.form.frequency_type === 1" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.km')" prop="kilometer">
                            <el-input-number v-model="state.form.kilometer" />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="state.form.frequency_type === 2" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.hours')" prop="kilometer">
                            <el-input-number v-model="state.form.hour" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.status')" prop="status">
                            <el-switch v-model="state.form.status" :active-value="1" :inactive-value="0"
                                :active-text="t('maintenance.enable')" :inactive-text="t('maintenance.disable')" />
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="close">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw
} from "vue";
import { ElMessage } from "element-plus";
import { saveApi } from "@/api/system/maintenance.js";
import { t } from "@/composables/usePageI18n.js";

const emit = defineEmits([]);
const props = defineProps({
    title: {
        type: String,
        default: "编辑保养项目",
    },
    device_id: {
        type: Number,
        default: 0,
    },
    plans_id: {
        type: Number,
        default: 0,
    },
});
const rules = reactive({
    title: [{ required: true, message: "请输入保养项目", trigger: "blur" }],
    content: [{ required: true, message: "请输入保养内容", trigger: "blur" }],
    required_materials: [{ required: true, message: "请输入物料", trigger: "blur" }],
    dose: [{ required: true, message: "请输入用量", trigger: "blur" }],
    frequency_type: [{ required: true, message: "请选择保养类型", trigger: "blur" }],
    day: [{ required: true, message: "请输入保养间隔时间", trigger: "blur" }],
    status: [{ required: true, message: "请选择状态", trigger: "blur" }],
    kilometer: [{ required: true, message: "请输入保养间隔公里数", trigger: "blur" }],
    hour: [{ required: true, message: "请输入保养间隔小时数", trigger: "blur" }],
});

const state = reactive({
    dialogVisible: false,
    form: {
        "id": 0,
        "plans_id": 0,
        "title": "",
        "content": "",
        "required_materials": "",
        "dose": "",
        "day": 0,
        "kilometer": 0,
        "frequency_type": 0,
        "status": 0,
        "hour": 0
    }
});

const getTemplateInfo = (row = {}) => {
    if (row?.id) {
        state.form = {
            ...row,
            required_materials: row.requiredMaterials,
            frequency_type: row.frequencyType,
        }
    } else {
        state.form.id = 0
    }

}

const open = (row) => {
    getTemplateInfo(row)
    state.dialogVisible = true;
};

const close = () => {
    state.dialogVisible = false
    state.form = {
        "id": 0,
        "plans_id": 0,
        "title": "",
        "content": "",
        "required_materials": "",
        "dose": "",
        "day": 0,
        "kilometer": 0,
        "frequency_type": 0,
        "status": 0,
        "hour": 0
    }
}

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const params = {
                ...toRaw(state.form),
                plans_id: props.plans_id,
                device_id: props.device_id
            }
            // return
            saveApi(JSON.stringify(params)).then(res => {
                if (res?.code === 200) {
                    ElMessage.success('操作成功')
                    state.dialogVisible = false
                    state.form = {
                        "id": 0,
                        "plans_id": 0,
                        "title": "",
                        "content": "",
                        "required_materials": "",
                        "dose": "",
                        "day": 0,
                        "kilometer": 0,
                        "frequency_type": 0,
                        "status": 0,
                        "hour": 0
                    }
                    emit('refresh')
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    try {
        if (row?.id) {
            getTemplateInfo();
        } else {
            form.id = 0
        }
    } catch (error) {

    }
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
    /* 可选，添加网格项之间的间隙 */
    // grid-template-columns: repeat(2, 1fr);
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}
</style>
